import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/lingo/DashboardLayout";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { FileText, BookOpen, Send } from "lucide-react";
import { toast } from "sonner";

export default function NotesAndAssignments() {
  const { user } = useAuth();
  const [tab, setTab] = useState("notes");
  const [notes, setNotes] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [text, setText] = useState({});

  const load = async () => {
    const [n, a] = await Promise.all([api.get("/notes"), api.get("/assignments")]);
    setNotes(n.data); setAssignments(a.data);
  };
  useEffect(() => { load(); }, []);

  const submit = async (aid) => {
    try {
      await api.post("/assignments/submit", { assignment_id: aid, content: text[aid] || "" });
      toast.success("Submitted");
      setText({ ...text, [aid]: "" });
    } catch { toast.error("Failed"); }
  };

  return (
    <DashboardLayout title="Library & Assignments">
      <div className="flex gap-2 mb-6">
        {[{ id: "notes", label: "Notes" }, { id: "assignments", label: "Assignments" }].map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`tab-${t.id}`}
            className={`px-5 py-2 rounded-full text-sm ${tab === t.id ? "bg-[#F77F00] text-white" : "border border-slate-200"}`}>{t.label}</button>
        ))}
      </div>

      {tab === "notes" && (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {notes.map((n) => (
            <div key={n.id} className="bg-white border border-slate-200 rounded-2xl p-6">
              <BookOpen className="w-5 h-5 text-[#F77F00] mb-3" />
              <div className="font-display text-lg">{n.title}</div>
              <div className="text-sm text-slate-500 mt-2">{n.content}</div>
              <div className="text-xs text-slate-400 mt-3">{n.test_type} · {n.section}</div>
            </div>
          ))}
          {!notes.length && <div className="col-span-3 text-slate-400">No notes yet.</div>}
        </div>
      )}

      {tab === "assignments" && (
        <div className="space-y-4">
          {assignments.map((a) => (
            <div key={a.id} className="bg-white border border-slate-200 rounded-2xl p-6">
              <FileText className="w-5 h-5 text-[#F77F00] mb-3" />
              <div className="font-display text-lg">{a.title}</div>
              <div className="text-sm text-slate-500 mt-2">{a.description}</div>
              <div className="text-xs text-slate-400 mt-2">Due: {a.due_date || "—"}</div>
              <div className="mt-4 flex gap-2">
                <input value={text[a.id] || ""} onChange={(e) => setText({ ...text, [a.id]: e.target.value })} placeholder="Your submission..." className="flex-1 bg-[#F6F8FB]/50 border border-slate-200 rounded-xl px-4 py-2" />
                <button onClick={() => submit(a.id)} className="px-4 py-2 rounded-xl bg-[#0047FF] inline-flex items-center gap-1"><Send className="w-4 h-4" /></button>
              </div>
            </div>
          ))}
          {!assignments.length && <div className="text-slate-400">No assignments yet.</div>}
        </div>
      )}
    </DashboardLayout>
  );
}
